import { render, staticRenderFns } from "./SelectableCustomerGroups.vue?vue&type=template&id=9778fb28&"
import script from "./SelectableCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./SelectableCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports